// Takes in v2 datamart filters as an object and returns a formatted string acceptable for API
export function formatDatamartFilters(params: object | null | undefined) {
  if (!params) return "";
  return Object.entries(params)
    .map(([key, value]) => `${key}:${value}`)
    .join(",");
}
